export const getFileInputState = ({ files, isDragActive, error, disabled, loading }) => {
  const fileCount = files.length;
  const isRepouso = fileCount === 0 && !isDragActive && !error && !disabled;
  const isDropping = isDragActive && !disabled;
  const isCarregamento = loading !== false && fileCount > 0;
  const isPreenchido = fileCount > 0 && !loading && !error;
  const isErro = !!error;
  const isDesabilitado = disabled;

  return {
    isRepouso,
    isDropping,
    isCarregamento,
    isPreenchido,
    isErro,
    isDesabilitado,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/FileInput/utils/fileInputHelpers.js